<template>
  <div
    class="dashboardstats"
    :class="{ gw_loading: stats_call.loading }"
  >
    <router-link
      class="gw_box flex-1"
      style="--box-padding: 0; min-width: 66%"
      :to="{ name: 'PracticeStats' }"
    >
      <div class="gw_box gw_box_widget_title">
        {{ $t('common.trainer_stats') }}

        <div
          class="mdi mdi-chevron-right clr-white ml-auto text-large line-height_1 pa-1 icon_btn csst csst_nm"
        >
          <div
            class="csst_content text-nowrap"
            style="left: -0.25em; transform: translate(-100%, 0)"
            v-html="$t('btn.see_more')"
          ></div>
        </div>
      </div>
      <div
        class="d-flex gw_box dashboardstats_hover-overlay"
        style="--box-padding: 0.5rem 1rem"
      >
        <PracticeStatsMainInfo
          class="dashboardstats_item gw_box"
          :items="practiceStats.topBoxes"
          style="
            background: transparent;
            --box-padding: 1.125rem;
            --size-title: 0.875rem;
            --size-value: 1.5rem;
            --gap: 1rem;
            --grid-template-columns: repeat(2, 1fr);
          "
        />
        <PracticeStatMovesChart
          class="gw_box"
          style="--clr-box-back: var(--clr-black-1); background: transparent"
          :items="practiceStats.moves"
        />
      </div>
    </router-link>
    <router-link
      class="gw_box dashboardstats_right"
      style="--box-padding: 0"
      :to="{ name: 'AnalyzeFilesV4' }"
    >
      <div class="gw_box gw_box_widget_title">
        {{ $t('common.analyzer_stats') }}

        <div
          class="mdi mdi-chevron-right clr-white ml-auto text-large line-height_1 pa-1 icon_btn csst csst_nm"
        >
          <div
            class="csst_content text-nowrap"
            style="left: -0.25em; transform: translate(-100%, 0)"
            v-html="$t('btn.see_more')"
          ></div>
        </div>
      </div>
      <div
        class="d-flex gw_box dashboardstats_hover-overlay"
        style="--box-padding: 0.5rem 1rem"
      >
        <PracticeStatsMainInfoV2
          v-if="$store.getters.user_has_flag('HHV2')"
          class="dashboardstats_item gw_box"
          style="
            background: transparent;
            --box-padding: 1.125rem;
            --size-title: 0.875rem;
            --size-value: 1.5rem;
            --gap: 1rem;
            --grid-template-columns: repeat(2, 1fr);
          "
        />
        <PracticeStatsMainInfo
          v-else
          class="dashboardstats_item gw_box"
          :items="hhStats.topBoxes"
          style="
            background: transparent;
            --box-padding: 1.125rem;
            --size-title: 0.875rem;
            --size-value: 1.5rem;
            --gap: 1rem;
            --grid-template-columns: repeat(2, 1fr);
          "
        />
      </div>
    </router-link>
    <slot></slot>
  </div>
</template>

<script>
import { getCorrectnessActionGroups } from '@/helpers/constants'
import { getTrainerScoreGroup } from '@/helpers/trainer'
import { getPercentageOfMax } from '@/helpers/helpers'
import PracticeStatsMainInfo from '@/components/PracticeHandsTotals/PracticeStatsMainInfo'
import PracticeStatMovesChart from '@/components/PracticeHandsTotals/PracticeStatMovesChart'
import PracticeStatsMainInfoV2 from '@/components/PracticeHandsTotals/PracticeStatsMainInfoV2'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import fetch_mix from '@/mixins/fetch_mix'

export default {
  name: 'DashboardStats',
  components: {
    PracticeStatsMainInfo,
    PracticeStatMovesChart,
    PracticeStatsMainInfoV2,
  },
  mixins: [float_mix, format_mix, fetch_mix],
  data() {
    return {
      tab: 'single_hand',
      tabOptions: [
        { id: 'practice_trainer', icon: 'mdi-google-controller' },
        { id: 'analyze', icon: 'mdi-lightbulb-on' },
      ],
      stats_call: {
        conf: {
          endpoint: 'poker/practice/practice-hands/totals/',
          apiVersion: 'v1',
        },
        loading: false,
        loaded: false,
        status: 0,
      },
      data: {
        totals: {},
        by_types: [],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const { data, error } = await this.fch_getData(this.stats_call)
      if (error) {
        return
      }
      this.data = data || { totals: {}, by_types: [] }
    },
    getPracticeData({ data }) {
      const groups = getCorrectnessActionGroups()
      let moves = [
        {
          name: this.$t(`practice.stats.bests`),
          id: 'best_moves_sum',
          group: groups.best_move,
        },
        {
          name: this.$t(`practice.stats.corrects`),
          id: 'correct_moves_sum',
          group: groups.correct_move,
        },
        {
          name: this.$t(`practice.stats.inaccuracy`),
          id: 'inaccuracy_moves_sum',
          group: groups.inaccuracy,
        },
        {
          name: this.$t(`practice.stats.wrongs`),
          id: 'wrong_moves_sum',
          group: groups.wrong_move,
        },
        {
          name: this.$t(`practice.stats.blunders`),
          id: 'blunder_moves_sum',
          group: groups.blunder,
        },
      ]

      const movesValues = moves.map(dd => data[dd.id])
      const max = Math.max(...movesValues)

      moves = moves.map(i => {
        const r = {
          ...i,
          value: this.numKtoM(data[i.id] || 0, 1000, 1),
          value_percent_scaled: getPercentageOfMax({
            max,
            value: data[i.id],
          }),
        }
        return r
      })
      const gto_score = {
        id: 'gto_score_avg',
        unit: '',
        value: this.numFixed((data.gto_score_avg || 0) * 100, 0),
        group: getTrainerScoreGroup(data.gto_score_avg),
      }

      const topBoxes = [
        {
          name: this.$t('common.hands'),
          value: this.numKtoM(data.total_hands || 0, 10000, 2),
        },
        {
          name: this.$t('common.moves'),
          value: this.numKtoM(data.played_moves_sum || 0, 10000, 2),
        },
        {
          name: this.$t('common.mistakes'),
          value: this.numKtoM(data.mistake_moves_sum || 0, 10000, 2),
        },
        {
          name: this.$t('common.gto_score'),
          value: gto_score.value || 0,
          unit: '%',
        },
      ]
      const res = {
        moves,
        topBoxes,
      }
      return res
    },
    getHHdata({ data }) {
      // console.log(moves)
      const topBoxes = [
        {
          name: this.$t('analyze.dashboard.total_hands_abbr'),
          value: this.numKtoM(data.total_hands || 0, 10000, 2),
        },
        {
          name: this.$t('analyze.dashboard.correct_plays_abbr'),
          value: this.numKtoM(data.correct_hands || 0, 10000, 2),
        },
        {
          name: this.$t('analyze.dashboard.wrong_plays_abbr'),
          value: this.numKtoM(data.mistake_hands || 0, 10000, 2),
        },
        {
          name: this.$t('analyze.dashboard.ev_mistake_abbr'),
          value: this.numFixedUnit(data.avg_ev_loss || 0, 'ev'),
          // unit: '%',
        },
      ]

      const res = {
        // moves,
        topBoxes,
      }
      return res
    },
  },
  computed: {
    practiceStats() {
      const data = this.data.totals
      const res = this.getPracticeData({ id: 'totals', data, skeleton: false })
      return res
    },
    hhStats() {
      const data =
        this.$store.getters.api_get_data('api_account_settings')?.hand_history_stats || {}
      const res = this.getHHdata({ data })

      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.dashboardstats {
  --gap: 1.5rem;
  --width-right: 20rem;
  --flex-direction: row;
  display: flex;
  flex-direction: var(--flex-direction);
  width: 100%;
  gap: var(--gap);
  cursor: pointer;
  &_item {
    margin: 0 0 auto 0;
  }
  &_right {
    min-width: var(--width-right);
  }
}

@media (hover: hover) and (pointer: fine) {
  .dashboardstats_hover-overlay {
    &::before {
      content: '';
      // background: rgba(255, 255, 255, 0.05);
      background: var(--clr-black-1-3);
      height: calc(100% - 1rem);
      width: calc(100% - 1rem);
      left: 0.5rem;
      top: 0.5rem;
      // left: 0;
      position: absolute;
      border-radius: 4px;
      overflow: hidden;
      z-index: 0;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
}

@media (max-width: 760px) {
  .dashboardstats {
    --flex-direction: column;
    --gap: 2rem;
  }
}
</style>
